
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          <div className="col-span-1 sm:col-span-2 lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4 sm:mb-6">
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-lg flex items-center justify-center shadow-lg border border-white p-0.5">
                <img 
                  src="https://static.readdy.ai/image/781a2fc213c4dd924fc481c5de3c6ab0/9fc51d80d983e85ecd697e3078ef132b.jfif"
                  alt="Lion Logo"
                  className="w-full h-full rounded object-cover"
                />
              </div>
              <div className="flex flex-col">
                <span className="text-lg sm:text-xl font-bold" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  Lions Trade Expert
                </span>
                <span className="text-sm text-amber-400 -mt-1">
                  Commodities Brasil
                </span>
              </div>
            </div>
            <p className="text-gray-300 max-w-md text-sm sm:text-base leading-relaxed">
              Portal informativo sobre a exportação de açúcar e café do Brasil para o mundo. 
              Dados atualizados, análises de mercado e informações sobre logística.
            </p>
          </div>

          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Navegação</h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/" 
                  className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base py-1 block min-h-[44px] flex items-center"
                >
                  Início
                </Link>
              </li>
              <li>
                <Link 
                  to="/acucar" 
                  className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base py-1 block min-h-[44px] flex items-center"
                >
                  Açúcar
                </Link>
              </li>
              <li>
                <Link 
                  to="/cafe" 
                  className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base py-1 block min-h-[44px] flex items-center"
                >
                  Café
                </Link>
              </li>
              <li>
                <Link 
                  to="/logistica" 
                  className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer text-sm sm:text-base py-1 block min-h-[44px] flex items-center"
                >
                  Logística
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4">Fontes de Dados</h3>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li className="py-1">CONAB</li>
              <li className="py-1">IBGE</li>
              <li className="py-1">MAPA</li>
              <li className="py-1">CECAFÉ</li>
              <li className="py-1">UNICA</li>
              <li className="py-1">FAO</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-6 sm:mt-8 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <p className="text-gray-400 text-sm text-center sm:text-left">
            © 2024 Lions Trade Expert. Todos os direitos reservados.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-amber-400 text-sm transition-colors cursor-pointer min-h-[44px] flex items-center px-2"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
